export const expensesConstants = {
  GET_EXPENSES_REQUEST: 'EXPENSES_GET_REQUEST',
  GET_EXPENSES_SUCCESS: 'EXPENSES_GET_SUCCESS',
  GET_EXPENSES_FAILURE: 'EXPENSES_GET_FAILURE',

  GET_EXPENSES_LIST_REQUEST: 'EXPENSES_LIST_GET_REQUEST',
  GET_EXPENSES_LIST_SUCCESS: 'EXPENSES_LIST_GET_SUCCESS',
  GET_EXPENSES_LIST_FAILURE: 'EXPENSES_LIST_GET_FAILURE',
};
